import { PusherEvent, useBusinessChannelEvent } from '~/pusher';
import { useStoreActions } from '~/store/store-context';
export function useKycStatusBinder() {
    const { fetchUserInfo } = useStoreActions();
    useBusinessChannelEvent({
        source: 'mgmt',
        eventName: PusherEvent.KYCStatusUpdated,
        // fetch user info to update the worksAt so the kyc failed banner will be shown
        callback: fetchUserInfo
    });
}
